import {
  Box,
  makeStyles,
  Theme,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import { InfoOutlined as InfoOutlinedIcon } from "@material-ui/icons";
import React from "react";

const HtmlTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: "white",
    color: "black",
    fontSize: theme.typography.pxToRem(12),
    border: "none",
    borderRadius: "0px",
    boxShadow: theme.shadows[1],
    padding: "0px",
  },
}))(Tooltip);

const useStyles = makeStyles({
  alert: {
    borderLeft: "4px solid #59baeb",
  },
});

interface Props {
  title: string;
  placement?:
    | "top-start"
    | "top"
    | "top-end"
    | "left-start"
    | "left"
    | "left-end"
    | "right-start"
    | "right"
    | "right-end"
    | "bottom-start"
    | "bottom"
    | "bottom-end";
}

const TooltipContent: React.FC<{ title: string }> = ({ title }) => {
  const classes = useStyles();
  return (
    <Box p={1} className={classes.alert}>
      <Typography variant="body2">{title}</Typography>
    </Box>
  );
};

export const TooltipWrapper: React.FC<Props> = (props) => {
  return (
    <HtmlTooltip
      placement={props.placement}
      title={<TooltipContent title={props.title} />}
    >
      <InfoOutlinedIcon fontSize="small" />
    </HtmlTooltip>
  );
};
